"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    AUTOMATIC_SUBSCRIPTION_NOTIFICATION_ID: true,
    SUBSCRIPTION_NOTIFICATION_APPEARANCE: true,
    BODY2_FONT_SIZE: true,
    ACCEPT_LANGUAGE: true,
    CLIENT_APPLICATION: true,
    TENANT_CONTEXT: true,
    MAX_WIDTH: true,
    MAX_MOBILE_ITEMS: true,
    MAX_DESKTOP_ITEMS: true,
    PERSONAL_SUBSCRIPTIONS: true
};
exports.TENANT_CONTEXT = exports.SUBSCRIPTION_NOTIFICATION_APPEARANCE = exports.PERSONAL_SUBSCRIPTIONS = exports.MAX_WIDTH = exports.MAX_MOBILE_ITEMS = exports.MAX_DESKTOP_ITEMS = exports.CLIENT_APPLICATION = exports.BODY2_FONT_SIZE = exports.AUTOMATIC_SUBSCRIPTION_NOTIFICATION_ID = exports.ACCEPT_LANGUAGE = void 0;
var _defaultBasketContext = require("./defaultBasketContext");
Object.keys(_defaultBasketContext).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _defaultBasketContext[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _defaultBasketContext[key];
        }
    });
});
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _defaultTranslations[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _defaultTranslations[key];
        }
    });
});
var _feature = require("./feature");
Object.keys(_feature).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _feature[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _feature[key];
        }
    });
});
var _productsStep = require("./productsStep");
Object.keys(_productsStep).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _productsStep[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _productsStep[key];
        }
    });
});
var _constantsGenerated = require("../constants-generated");
Object.keys(_constantsGenerated).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _constantsGenerated[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _constantsGenerated[key];
        }
    });
});
// Subscriptions
const AUTOMATIC_SUBSCRIPTION_NOTIFICATION_ID = exports.AUTOMATIC_SUBSCRIPTION_NOTIFICATION_ID = '1004';
const SUBSCRIPTION_NOTIFICATION_APPEARANCE = exports.SUBSCRIPTION_NOTIFICATION_APPEARANCE = 128;
const BODY2_FONT_SIZE = exports.BODY2_FONT_SIZE = '1.6rem';
// Header
const ACCEPT_LANGUAGE = exports.ACCEPT_LANGUAGE = 'accept-language';
const CLIENT_APPLICATION = exports.CLIENT_APPLICATION = 'x-client-application';
const TENANT_CONTEXT = exports.TENANT_CONTEXT = 'x-tenant-context';
// Max width
const MAX_WIDTH = exports.MAX_WIDTH = 980;
// Subscription items
const MAX_MOBILE_ITEMS = exports.MAX_MOBILE_ITEMS = 3;
const MAX_DESKTOP_ITEMS = exports.MAX_DESKTOP_ITEMS = 6;
const PERSONAL_SUBSCRIPTIONS = exports.PERSONAL_SUBSCRIPTIONS = '7D673EF4-D085-44B5-BB1C-8FE57F1286BD';
